import React, { useEffect, useState, useContext } from "react";
import jMoment from "moment-jalaali";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ProcessCardContainer from "../components/ProcessCardContainer";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import { useSnackbar } from "notistack";
import { AuthContext } from "../../context/AuthContext";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import AdapterJalaali from "@date-io/jalaali";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import OrderDetailsInitials from "../components/OrderDetailsInitials";
import MessagesContainer from "../components/MessagesContainer";
import { baseUrl } from "../../baseUrl";
import PredictionDate from "../components/PredictionDate";
import FinishDate from "../components/FinishDate";

// the problem is that the loading is set to false imidietly when the component starts
// because it loads the paper imidietly

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const OrderDetails = () => {
  const auth = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();
  const orderId = useParams().oId;

  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => {
    setOpen2(true);
  };
  const handleClose2 = () => setOpen2(false);

  const [isLoading, setIsLoading] = useState(true);
  const [orderTypes, setOrderTypes] = useState();
  const [doctorNames, setDoctorNames] = useState();
  const [process, setProcess] = useState();
  const [lastProcess, setLastProcess] = useState();
  const [orderTypeProcesses, setOrderTypeProcesses] = useState([]);
  const [status, setStatus] = useState(null);
  const [initials, setInitials] = useState();
  const [updater, setUpdater] = useState(0);

  const updaterHandler = () => {
    setUpdater((updater) => updater + 1);
  };

  const [isValidInitials, setisValidInitials] = useState(true);

  jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

  //getting the route it came from
  const prevRoute = useSelector((state) => state.routeReducer.prevRoute);
  const navigate = useNavigate();

  //test
  useEffect(() => {
    console.log(isLoading);
  }, [isLoading]);

  //handle delete order
  const deleteHandler = () => {
    setIsLoading(true);
    axios
      .delete("/api/v1/laboratorys/delete-order", {
        data: {
          orderId: Number(orderId),
        },

        headers: {
          "Content-Type": "application/json",
          authorization: auth.token,
        },
      })
      .then((response) => {
        enqueueSnackbar(response.data.message.message, {
          variant: "success",
        });
        setStatus(1);
        navigate(prevRoute);
        console.log("should be closed ...");
        handleClose2();
      })
      .catch((e) => {
        const messages = e.response.data.data;
        Array.isArray(messages)
          ? messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            })
          : enqueueSnackbar(messages, { variant: "error" });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // getting orderTypes
  useEffect(() => {
    async function sendRequest() {
      try {
        const response = await fetch(
          baseUrl + `/api/v1/laboratorys/get-orderTypes`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: auth.token,
            },
            body: JSON.stringify({
              onlyName: true,
              page: 0,
              rowCount: 0,
            }),
          }
        );
        const responseData = await response.json();
        if (!response.ok) {
          throw new Error(response.message);
        }
        setOrderTypes(responseData.data.result);
      } catch (err) {
        err.data.map((error) => {
          enqueueSnackbar(error, { variant: "error" });
        });
        setIsLoading(false);
      }
    }

    sendRequest();
  }, []);

  //getting doctor names
  useEffect(() => {
    async function sendRequest() {
      try {
        const response = await fetch(
          baseUrl + `/api/v1/laboratorys/get-doctors`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: auth.token,
            },
            body: JSON.stringify({
              onlyName: true,
              page: 1,
            }),
          }
        );
        const responseData = await response.json();
        if (!response.ok) {
          throw new Error(response.message);
        }
        setDoctorNames(responseData.data.result);
      } catch (err) {
        err.data.map((error) => {
          enqueueSnackbar(error, { variant: "error" });
        });
        setIsLoading(false);
      }
    }

    sendRequest();
  }, []);

  //getting order details and process
  useEffect(() => {
    axios
      .post(
        "/api/v1/laboratorys/get-order-process",
        {
          orderId: Number(orderId),
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        setInitials(response.data.data);
        setProcess(response.data.data.process);
        const lastProcessIndex = response.data.data.process.length - 1;
        setLastProcess(response.data.data.process[lastProcessIndex]);
        setStatus(response.data.data.status);
      })
      .catch((e) => {
        setIsLoading(false);
        const messages =
          e.response.data.data != null
            ? e.response.data.data
            : e.response.data.message.message;
        Array.isArray(messages)
          ? messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            })
          : enqueueSnackbar(messages, { variant: "error" });
      });
  }, []);

  //getting order-type-processes
  useEffect(() => {
    initials &&
      axios
        .post(
          "/api/v1/laboratorys/get-orderType-process",
          {
            orderTypeId: initials.orderTypeId,
          },
          {
            headers: {
              "Content-Type": "application/json",
              authorization: auth.token,
            },
          }
        )
        .then((response) => {
          setOrderTypeProcesses(response.data.data);
          setIsLoading(false);
        })
        .catch((e) => {
          const messages = e.response.data.data;
          setIsLoading(false);
          messages.map((message) => {
            enqueueSnackbar(message, { variant: "error" });
          });
        });
  }, [initials]);

  //handling loading
  // useEffect(() => {
  //   initials &&
  //     orderTypes &&
  //     doctorNames &&
  //     orderTypeProcesses &&
  //     setIsLoading(false);
  // }, [initials, orderTypes, doctorNames, orderTypeProcesses]);

  return (
    <React.Fragment>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {!isLoading && (
        <Paper sx={{ flexGrow: 1, maxWidth: 1200, p: 4 }}>
          <React.Fragment>
            <div>
              <Modal open={open2} onClose={handleClose2}>
                <Box sx={style}>
                  <Typography variant="h6" component="h2">
                    هشدار
                  </Typography>
                  <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    آیا مطمئنید که می خواهد این سفارش را حذف کنید ؟
                  </Typography>
                  <Grid container spacing={3} sx={{ mt: 2 }}>
                    <Grid xs={6}>
                      <Button
                        fullWidth
                        color="error"
                        variant="contained"
                        onClick={deleteHandler}
                      >
                        بله
                      </Button>
                    </Grid>
                    <Grid xs={6}>
                      <Button
                        fullWidth
                        color="primary"
                        variant="contained"
                        onClick={handleClose2}
                      >
                        خیر
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>
            </div>
            <Grid container spacing={5}>
              <Grid xs={12} md={6}>
                <Button
                  fullWidth
                  color="error"
                  variant="outlined"
                  onClick={handleOpen2}
                >
                  <DeleteIcon sx={{ mx: 1 }} />
                  حذف کار
                </Button>
              </Grid>

              <Grid xs={12} md={6}>
                <Link
                  to={prevRoute}
                  style={{
                    color: "inherit",
                    textDecoration: "inherit",
                  }}
                >
                  <Button fullWidth color="primary" variant="contained">
                    <ArrowBackIcon
                      sx={{ mx: 1 }}
                      onClick={() => {
                        navigate(prevRoute);
                      }}
                    />
                    بازگشت
                  </Button>
                </Link>
              </Grid>
            </Grid>

            {!isLoading && initials && doctorNames && (
              <>
                <OrderDetailsInitials
                  data={initials}
                  doctorNames={doctorNames}
                  orderTypes={orderTypes}
                  setIsValid={setisValidInitials}
                />
              </>
            )}

            {!isLoading && initials && process && status == 0 && (
              <PredictionDate
                orderId={orderId}
                process={process[process.length - 1]}
              />
            )}

            {!isLoading && initials && !status == 0 && (
              <FinishDate
                endDate={initials.endDate}
                processEndDate={lastProcess.endDate}
                status={initials.status}
                orderId={orderId}
              />
            )}

            <ProcessCardContainer
              orderProcesses={process}
              orderTypeProcesses={orderTypeProcesses}
            />
            <MessagesContainer orderId={orderId} />
          </React.Fragment>
        </Paper>
      )}
    </React.Fragment>
  );
};

export default OrderDetails;
